$(document).ready(function () {
  const bsubBtn = $("[data-bsub-selling-plan-group-input]");
  const optionBtn = $(".option-value-name");

  bsubBtn.click(function () {
    return showRightPriceOnClick();
  });

  optionBtn.click(function () {
    setTimeout(() => {
      showRightPriceOnClick();
    }, 200);
  });

  function showRightPriceOnClick() {
    const plansRef = $(".bsub-widget__plans-container");
    const priceRef = $(".custom-money");

    let subProductPriceRef = $(".sub-product-price");
    let priceElRef = $("[data-bsub-per-delivery-price]");
    const earnedPoints = Math.round(priceElRef.html().slice(1) * 1);
    console.log("earnedPoints: ", earnedPoints);
    subProductPriceRef.text(`${priceElRef.html()} (10% Saving)`);
    subProductPriceRef.append(
      `<span class="product-points">&nbsp; - &nbsp;${earnedPoints} Points</span>`
    );

    setTimeout(() => {
      if (plansRef.hasClass("bsub__hidden")) {
        subProductPriceRef.hide();
        priceRef.show();
      } else {
        priceRef.hide();
        subProductPriceRef.show();
      }
    }, 1);
  }
});
